import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { WorkerCaptureAuditReport } from './Pages/listing'

export const WorkerCaptureAuditReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={WorkerCaptureAuditReport} />
    </Fragment>
)
